'use strict';

var React = require('react');

var SvgDigitalMediaReceiverMajor = function SvgDigitalMediaReceiverMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 10a8 8 0 0 1 8-8 1 1 0 1 0 0-2c-5.523 0-10 4.477-10 10a1 1 0 1 0 2 0zm8-4a4 4 0 0 0-4 4 1 1 0 1 1-2 0 6 6 0 0 1 6-6 1 1 0 1 1 0 2zm1 4a1 1 0 0 1 1 1v3h6.5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h6.5v-3a1 1 0 0 1 1-1zm-4 6h-3v2h3v-2z"
  }));
};

exports.SvgDigitalMediaReceiverMajor = SvgDigitalMediaReceiverMajor;
